import { render, staticRenderFns } from "./BaseFormText.vue?vue&type=template&id=3f10dc64&"
import script from "./BaseFormText.vue?vue&type=script&lang=js&"
export * from "./BaseFormText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports